export default {
  title: 'Datos de factura',
  invoice_form: {
    description: 'Para continuar con tu compra, según el',
    description_bold: 'acuerdo gubernativo 245-2022',
    extended_description: 'del Ministro de Finanzas Públicas en compras',
    extended_description_bold: 'mayores o igual a Q 2500.',
    final_description: 'Debes ingresar tu número de NIT/DPI ó pasaporte (Aplica a extranjeros).',
    info_label: 'Ingresa la siguiente información para la generación de tu factura.',
    warning_label:
      'En caso de que no desees datos de facturación, se generará una factura como consumidor final.',
    input_name: {
      label: 'Nombre en factura:',
      placeholder: 'Ingresa el nombre',
      error: {
        required: 'El campo nombre es requerido',
        format: 'Debe especificar un nombre válido'
      }
    },
    input_nit: {
      label: 'NIT:',
      placeholder: 'Ingresa el NIT',
      error: {
        required: 'El campo NIT es requerido',
        format: 'Debe especificar un NIT válido'
      }
    },
    input_address: {
      label: 'Dirección de facturación:',
      placeholder: 'Ingresa la dirección de facturación',
      error: {
        length: 'Su dirección debe de contener máximo 200 caracteres'
      }
    },
    input_email: {
      label: 'Correo electrónico para tu factura:',
      placeholder: 'Ingresa tu correo',
      error: {
        format: 'Debe especificar un correo electrónico válido',
        domain: 'Debe especificar un correo @gmail.com, @hotmail.com, @msn.com o @outlook.com'
      }
    }
  },
  radio_buttons: {
    yes_invoice: 'Deseo recibir mi factura por correo electrónico (opcional).',
    no_invoice: 'No deseo factura'
  }
}
